import { useIntl } from "react-intl";
import { Modal } from "../../common/components/Modal1"; // Ensure this path is correct
import { useEffect, useRef, useState } from "react";
import { fetchPromoUrl } from "../../auth/api/loginapi"; // Ensure this path is correct
import { CheckIsNull } from "../../../utils/CommonHelper"; // Ensure this path is correct

export const PromotionReviewModal = ({ language, openfrom, ipaddress }) => {
  const intl = useIntl();
  const iframeRef = useRef();
  const dismissBtnRef = useRef();
  const [height, setHeight] = useState("600px");
  const [promourl, setPromourl] = useState("");

  useEffect(() => {
    const queryParams = `openfrom=${openfrom}&language=${language}&platform=mobile&ipaddress=${ipaddress}`;

    fetchPromoUrl(queryParams).then((res) => {
      if (!CheckIsNull(res.promourl)) {
        setPromourl(res.promourl);
      }
    });
  }, [language, openfrom, ipaddress]);

  useEffect(() => {
    const platform = sessionStorage.getItem("platform");

    if (platform === "telegram" && dismissBtnRef.current) {
      // Trigger the dismiss button click to close the modal
      dismissBtnRef.current.click();
    }
  }, []);

  return (
    <Modal modalId="promotionReviewModal" dismissBtnRef={dismissBtnRef}>
      <div>
        <iframe
          src={promourl}
          ref={iframeRef}
          height={height}
          className="w-100"
          frameBorder="0"
        />
      </div>
    </Modal>
  );
};
